export default {
  title: {
    en: 'Skip to main content',
  },
  skipQueueTitle: {
    en: 'Skip queue to main content',
  },
}
